import {
  RolodexEntryJson,
  RolodexEntryType,
} from 'types/rolodex/rolodexEntries'
import { parseString } from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'

/**
 * An entry that holds an Observation taken from site - right now uesed for adding indications to point clouds
 */
export class GeckoGeographicPin extends GeckoEntryBase<
  {
    geo_json: GeoJSON.Feature
    name?: string
    link?: string
  },
  {
    site: string
    organization: string
    [RolodexEntryType.POTREE_POINT_CLOUD]?: string
    [RolodexEntryType.UNIT]?: string
    [RolodexEntryType.REPORT]?: string
  }
> {
  //----------------------------------------------------------------------------

  /**
   * A simple constructor, private so that a more descriptive factory method
   * (which can return undefined) is used instead
   * @param json The raw JSON to create an instance from
   * @private
   */
  private constructor(json: RolodexEntryJson) {
    super(
      json,
      {
        geo_json: json.data.geo_json as GeoJSON.Feature,
        name: parseString(json.data.name),
        link: parseString(json.data.link),
      },
      {
        organization: parseString(json.tags.organization) ?? '',
        site: parseString(json.tags.site) ?? '',
        [RolodexEntryType.POTREE_POINT_CLOUD]: parseString(
          json.tags[RolodexEntryType.POTREE_POINT_CLOUD]
        ),
        [RolodexEntryType.UNIT]: parseString(json.tags[RolodexEntryType.UNIT]),
        [RolodexEntryType.REPORT]: parseString(
          json.tags[RolodexEntryType.REPORT]
        ),
      },
      {}
    )
  }

  //----------------------------------------------------------------------------

  /**
   * A simple factory method which creates a point cloud from raw JSON
   * @param json The raw JSON to create an instance from
   * @constructor
   */
  public static CreateFromJSON(json: RolodexEntryJson) {
    return new GeckoGeographicPin(json)
  }
}
